/* THE ONE AUDIENCE PREDICATE (W-035).
   Who is the operator? Today: the super admin (Brian), the only user with role 'super_admin'; tenant users
   are role 'admin'. Every "operator only" surface asks HERE -- the company switcher, the Admin page's
   Onboarding tab, the Health Check tab -- so W-053 (formal user roles) changes ONE line.
   This is DISPLAY gating (who is shown a control), not security: the server enforces its own gates. */
export function isSuperAdmin(user) {
    return !!user && user.role === 'super_admin';
}

/* W-053 step 3a: who may manage the company's logins (the Admin page's Add User tab). A company admin and the super admin;
   NOT a viewer (Brian D2: viewers do not see the tab at all). Display gating only -- the server refuses a viewer every
   user-management route (its role gate). */
export function canManageUsers(user) {
    return !!user && (user.role === 'admin' || user.role === 'super_admin');
}

/* W-053 step 3b: who may CHANGE THE MODEL (every write a page makes, except a user's own scenarios and own password).
   A company admin and the super admin; any other role is view-only. This is the SERVER's own rule, spelled a second time
   across THE WALL: roleGateRefusal's `isAdmin` (server.js) refuses every non-GET outside VIEWER_WRITE_ALLOW to anyone else
   ('Your login is view-only.'). The pair is wall mirror M14 (server/diagnostics/verify-wall-mirrors.js) -- change both or
   neither. Kept apart from canManageUsers on purpose (same truth table today, a different question). Display gating only. */
export function canEditModel(user) {
    return !!user && (user.role === 'admin' || user.role === 'super_admin');
}
